import { Link } from "react-router-dom";

type Movie = {
  id: string;
  title: string;
  year: string;
  genre: string;
  rating: number;
  duration: string;
  poster: string;
};

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to="/watch"
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-500 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent opacity-90" />
        <span className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-md bg-background-50/85 text-accent-500 text-xs font-medium backdrop-blur-sm">
          <i className="ri-star-fill text-[11px]" />
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-3 left-3 flex items-center gap-1 text-xs text-foreground-800">
          <i className="ri-time-line" />
          {movie.duration}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 truncate group-hover:text-accent-500 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1.5 text-xs text-secondary-500 truncate">
          {movie.year} · {movie.genre}
        </p>
      </div>
    </Link>
  );
}